export default __webpack_public_path__ + "static/media/thumbnail.c413898d.png";